/**
* 支付管理 支付配置
*/
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>营收记录</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
        <el-date-picker v-model="value" type="daterange" range-separator="至" start-placeholder="开始日期"
          end-placeholder="结束日期" @change="selectTime">
        </el-date-picker>
      </el-form-item>
    </el-form>
    <el-col :span="36">
      <!-- 六个订单信息 -->
      <div class="num">
        <el-card shadow="hover" v-for="item in countData" :key="item.name" :body-style="{ display: 'flex', padding: 0 }"
          class="OrderCard">
          <i class="icon" :class="'el-icon-' + item.icon" :style="{ background: item.color }"></i>
          <div class="textBox">
            <p class="important-font">￥{{ item.value }}</p>
            <p class="secondary-font">{{ item.name }}</p>
          </div>
        </el-card>
      </div>
    </el-col>
    <el-table size="small" :data="message.maplist" highlight-current-row v-loading="loading" border
      element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column align="center" type="index" width="60">
      </el-table-column>
      <el-table-column prop="time" label="时间" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="turnover" label="营业额" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="profit" label="利润" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="totalOrderNum" label="订单量" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="totalNum" label="商品量" show-overflow-tooltip>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <!-- <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination> -->
  </div>
</template>

<script>
import { ConfigList, ConfigSave, ConfigDelete } from "../../api/payMG";
import Pagination from "../../components/Pagination";
import { getSalesRecord } from '../../api/api.js'
export default {
  data() {
    return {
      loading: false, //是显示加载
      // editFormVisible: false, //控制编辑页面显示与隐藏
      //6个表格的内容
      countData: [
        {
          name: "总营业额",
          value: 1200,
          icon: "success",
          color: "#2ec7c9",
        },
        {
          name: "日最高营业额",
          value: 1200,
          icon: "star-on",
          color: "#ffb980",
        },
        {
          name: "日均营业额",
          value: 1200,
          icon: "s-goods",
          color: "#5ab1ef",
        },
        {
          name: "总利润",
          value: 1200,
          icon: "success",
          color: "#2ec7c9",
        },
        {
          name: "日最高利润",
          value: 1200,
          icon: "star-on",
          color: "#ffb980",
        },
        {
          name: "日均利润",
          value: 1200,
          icon: "s-goods",
          color: "#5ab1ef",
        },
      ],
      value: "",//获取的时间
      message: '',//营销数据
      formInline: {
        page: 1,
        limit: 10,
        name: "",
        payType: 0,
        partner: "",
        token: localStorage.getItem("logintoken"),
      },
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10,
      },
    };
  },
  // 注册组件
  components: {
    Pagination,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {

    // 1. 获取当前时间作为基准
    let now = new Date();

    // 2. 设置结束时间为昨天 (当前日期减1)
    let endDate = new Date();
    endDate.setDate(now.getDate() - 1);

    // 3. 设置开始时间为当前时间减10天
    let startDate = new Date();
    startDate.setDate(now.getDate() - 10);

    // 4. 赋值给组件绑定的变量 (确保是日期对象数组)
    let date = [startDate, endDate];
    this.value = date;

    // 5. 执行数据获取逻辑
    this.getdata(date);
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 获取营销数据
    getdata(date) {
      // 1. 数据校验：防止传参为空导致 new Date() 报错
      if (!date || !date[0] || !date[1]) {
        console.error("时间参数错误", date);
        return;
      }

      // 2. 格式化日期
      let startDate = new Date(date[0]);
      let endDate = new Date(date[1]);

      this.startTime =
        startDate.getFullYear() +
        "-" +
        ("0" + (startDate.getMonth() + 1)).slice(-2) +
        "-" +
        ("0" + startDate.getDate()).slice(-2);
      this.endTime =
        endDate.getFullYear() +
        "-" +
        ("0" + (endDate.getMonth() + 1)).slice(-2) +
        "-" +
        ("0" + endDate.getDate()).slice(-2);

      const storeId = localStorage.getItem('storeId');

      // 3. 构建唯一缓存 Key
      // 这样当日期不一样时，Key 就不一样，本地存储也就相互独立了
      const cacheKey = `sales_record_${storeId}_${this.startTime}_${this.endTime}`;

      // 4. 处理并展示数据的公共方法
      const renderData = (data) => {
        this.message = data;
        // 赋值给 countData 数组
        this.countData[0].value = data.totalTurnover;
        this.countData[1].value = data.maxTurnover;
        this.countData[2].value = data.avgTurnover;
        this.countData[3].value = data.totalProfit;
        this.countData[4].value = data.maxProfit;
        this.countData[5].value = data.avgProfit;
      };

      // 5. 尝试从本地获取
      const localData = localStorage.getItem(cacheKey);
      if (localData) {
        try {
          const parsedData = JSON.parse(localData);
          console.log("🚀 命中营销数据缓存");
          renderData(parsedData);
          return; // 直接结束，不发请求
        } catch (e) {
          localStorage.removeItem(cacheKey); // 容错处理
        }
      }

      // 6. 如果没有缓存，则发送网络请求
      this.loading = true;
      getSalesRecord({
        startTime: this.startTime,
        endTime: this.endTime,
        storeId: storeId,
      }).then((res) => {
        this.loading = false;
        if (res.code == 0) {
          renderData(res.data);
          // 7. 存储到本地
          localStorage.setItem(cacheKey, JSON.stringify(res.data));
          console.log("✅ 营销数据请求完成并缓存");
        } else {
          this.$message({
            type: "info",
            message: res.msg,
          });
        }
      }).catch((err) => {
        this.loading = false;
        this.$message.error("营销数据获取失败，请稍后再试！");
      });
    },
  
    // 选择时间触发的函数
    selectTime(date) {
      this.getdata(date);
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage;
      this.formInline.limit = parm.pageSize;
      this.getdata(this.formInline);
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline);
    },
    //显示编辑界面
    handleEdit: function (index, row) {
      this.editFormVisible = true;
      if (row != undefined && row != "undefined") {
        this.title = "修改";
        this.editForm.id = row.id;
        this.editForm.name = row.name;
        this.editForm.payType = row.payType;
        this.editForm.partner = row.partner;
        this.editForm.subMchId = row.subMchId;
        this.editForm.appid = row.appid;
        this.editForm.notifyUrl = row.notifyUrl;
        this.editForm.signType = row.signType;
        this.editForm.partnerKey = row.partnerKey;
        this.editForm.sellerUserId = row.sellerUserId;
        this.editForm.certPath = row.certPath;
        this.editForm.certPassword = row.certPassword;
        this.editForm.rsaKey = row.rsaKey;
      } else {
        this.title = "添加";
        this.editForm.id = "";
        this.editForm.name = "";
        this.editForm.payType = "";
        this.editForm.partner = "";
        this.editForm.subMchId = "";
        this.editForm.appid = "";
        this.editForm.notifyUrl = "";
        this.editForm.signType = "";
        this.editForm.partnerKey = "";
        this.editForm.sellerUserId = "";
        this.editForm.certPath = "";
        this.editForm.certPassword = "";
        this.editForm.rsaKey = "";
      }
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate((valid) => {
        if (valid) {
          ConfigSave(this.editForm)
            .then((res) => {
              this.editFormVisible = false;
              this.loading = false;
              if (res.success) {
                this.getdata(this.formInline);
                this.$message({
                  type: "success",
                  message: "公司保存成功！",
                });
              } else {
                this.$message({
                  type: "info",
                  message: res.msg,
                });
              }
            })
            .catch((err) => {
              this.editFormVisible = false;
              this.loading = false;
              this.$message.error("支付配置信息保存失败，请稍后再试！");
            });
        } else {
          return false;
        }
      });
    },
    // 删除公司
    deleteUser(index, row) {
      this.$confirm("确定要删除吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          ConfigDelete(row.deptId)
            .then((res) => {
              if (res.success) {
                this.$message({
                  type: "success",
                  message: "公司已删除!",
                });
                this.getdata(this.formInline);
              } else {
                this.$message({
                  type: "info",
                  message: res.msg,
                });
              }
            })
            .catch((err) => {
              this.loading = false;
              this.$message.error("支付配置信息删除失败，请稍后再试！");
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 关闭编辑、增加弹出框
    closeDialog(formName) {
      this.editFormVisible = false;
      this.$refs[formName].resetFields();
    },
  },
};
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}

.userRole {
  width: 100%;
}

.num {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
}

.OrderCard {
  margin: 0 0 20px 30px;
  border: #dcdfe6 1px solid;
  border-radius: 10px;
  /* height: 80px; */
}

.icon {
  width: 30%;
  line-height: 100px;
  font-size: 30px;
  color: #fff;
  text-align: center;
}

.textBox {
  /* background-color: red; */
  width: 33vw;
  text-align: center;
}

.important-font {
  font-weight: 900;
  font-size: 20px;
}

.secondary-font {
  color: #909399;
}
</style>



// WEBPACK FOOTER //
// src/views/pay/Config.vue